/**
 * BlankBox Component
 * Ported from reference_legacy/quebon-lms-web/components/lesson/quiz-types/shared/blank-box.tsx
 */

import { ReactNode } from 'react'

interface BlankBoxProps {
  children: ReactNode
}

export default function BlankBox({ children }: BlankBoxProps) {
  return (
    <span className="inline-flex items-center justify-center border-gray-300 bg-white border-2 rounded-md h-10 px-2 mx-1 text-center min-w-[40px]">
      {children}
    </span>
  )
}
